const locale = {
    methods: {
        localeOrderStatus(status) {
            return this.$t(`ordersStatus.${status}`)
        },
    },
}

export default locale
